import ApiError from '../../../../entities/api-error/ApiError'
import { OrderProduct } from '../../../../entities/order-product/OrderProduct'
import DashboardActionTypes from './DashboardActionTypes'

export interface RequestRemoveLabels {
  type: DashboardActionTypes.REQUEST_REMOVE_LABELS;
  payload: {
    products: OrderProduct[]
  }
}

export function requestRemoveLabels({
  products,
}: RequestRemoveLabels['payload']): RequestRemoveLabels {
  return {
    type: DashboardActionTypes.REQUEST_REMOVE_LABELS,
    payload: {
      products,
    },
  }
}

export interface RequestRemoveLabelsSuccess {
  type: DashboardActionTypes.REQUEST_REMOVE_LABELS_SUCCESS;
  payload: {
    products: OrderProduct[]
  }
}

export function requestRemoveLabelsSuccess({
  products,
}: RequestRemoveLabelsSuccess['payload']): RequestRemoveLabelsSuccess {

  return {
    type: DashboardActionTypes.REQUEST_REMOVE_LABELS_SUCCESS,
    payload: {
      products,
    },
  }
}

export interface RequestRemoveLabelsFailure {
  type: DashboardActionTypes.REQUEST_REMOVE_LABELS_FAILURE;
  payload: {
    products:  OrderProduct[]
    error:    ApiError;
  }
}

export function requestRemoveLabelsFailure({
  products,
 error,
}: RequestRemoveLabelsFailure['payload']): RequestRemoveLabelsFailure {

  return {
    type: DashboardActionTypes.REQUEST_REMOVE_LABELS_FAILURE,
    payload: {
      products,
      error,
    },
  }
}
